<template>
  <div>
    <br />
    <!-- <div class="row row-sm">
      <div class="col-12 col-md-6 col-lg-3 col-xl-3">
        <label for="">
          Client
        </label>

        <vue-select :options="customers" v-model="filter.customer_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />


      </div>


      <div class="col-xl col-12 ">
        <label for="itemInput">Produit</label>

        <vue-select :options="items" v-model="filter.item_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />
      </div>

      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale8") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>
      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale9") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      <div class="col-12 col-md-6 col-lg-2 col-xl-2">
        <label for=""> {{ $t("sale10") }} </label>
        <select v-model="filter.paymentStatus" class="form-select">
          <option value="--">--</option>
          <option value="paid">Payé</option>
          <option value="Unpaid">Impayé</option>
        </select>
      </div>
    </div> -->
    <!-- <div class="row justify-content-end">
      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="toFilter(filter)" class="btn btn-secondary">
          <i class="bi bi-funnel"></i>
          {{ $t("sale11") }}
        </button>
      </div>

      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          {{ $t("sale12") }}
        </button>
      </div>

      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="printMany(selections)" class="btn btn-secondary">
          <i class="bi bi-printer"></i>
          Imprimer BL
        </button>
      </div>

      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="$router.push({ name: 'sales-items-create' })" class="btn btn-primary">
          <i class="bi bi-person-plus"></i>
          {{ $t("sale13") }}
        </button>
      </div>

    </div> --> 
    <vue-data-table :headers="headers" :data="sales" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns"
      :tableActions="tableActions"
      
      
      :filterFields="filterFields"
      :filterData="filter"
      filterTitle="Filtrer les ventes"
      @filter="toFilter"
      @reset="resetFilter"
      >

      <template #cell-invoiceReference="{ row }">
        <span class="px-2 py-1 rounded " :class="row.invoiceReference !== 'Non Généré' ?
          'bg-light-success text-success' : 'bg-light-danger text-danger'">
          {{ row.invoiceReference }}
        </span>
      </template>

      <template #cell-amountPaid="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.amountPaid > 0 && row.amountPaid == row.totalPriceTTC ?
            'bg-light-success text-success' : row.amountPaid > 0 && row.amountPaid < row.totalPriceTTC ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.amountPaid > 0 ? row.amountPaid : " Impayé " }}
        </span>
      </template> 

      <template #cell-orderTotalPriceTTC="{ row }">
        <span v-if="row.orderTotalPriceTTC != row.totalPriceTTC
          && row.passPermit != ''
          && parseFloat(row.orderTotalPriceTTC) + parseFloat(row.totalQuantity) != parseFloat(row.totalPriceTTC)"
          class="px-2 py-1 rounded bg-light-warning text-success">
          <i class="bi bi-exclamation-triangle"></i>
          {{ parseFloat(row.orderTotalPriceTTC) | toFixedWithSpace }}
        </span>
        <span v-else>

        </span>
      </template>

      <template #cell-passPermit="{ row }">
        <span class="px-2 py-1 rounded  ">
          {{ row.passPermit ? "LP" + row.passPermit : "-" }}
        </span>
      </template>


      <template #cell-validated="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.validated ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
          <!-- {{ row.validated }} -->
          {{ row.validated ? "Validé" : "Validé" }}
        </span>
      </template>

    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import SaleDataTableVue from "../../components/cards/SaleDataTable.vue";
export default {
  // components: { SaleDataTableVue },
  data() {
    return {
      filter: {
        customer_reference: null,
        item_reference: null,
        startDate: null,
        endDate: null,
      },
      selections: [],
      headers: [
        { field: 'reference', label: 'BL', class: '' },
        { field: 'invoiceReference', label: 'Facture', class: '' },
        { field: 'order_reference', label: 'BC', class: '' },
        { field: 'customerFullName', label: 'Client', class: '' },
        { field: 'date', label: 'Date', class: '' },
        { field: 'totalPriceTTC', label: 'Total TTC', class: 'text-primary' },
        { field: 'orderTotalPriceTTC', label: 'Recalculer', class: 'text-primary' },
        { field: 'totalQuantity', label: 'Quantité Totale', class: '' },
        { field: 'amountPaid', label: 'Montant payé', class: 'text-success' },
        { field: 'amountUnpaid', label: 'Montant impayé', class: 'text-danger' },
        { field: 'passPermit', label: 'LP', class: '' },
        { field: 'validated', label: 'État', class: 'text-danger' },
        { field: 'remark', label: 'NB', class: 'text-danger' },
        { field: 'userName', label: 'Utilisateur', class: '' },
      ],
      buttons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-square',
          class: 'btn btn-primary',
          action: (sale) => {
            this.$router.push({
              name: 'sales-details',
              params: { reference: sale.reference },
            });
          },
        },
        {
          label: 'Imprimer BL',
          icon: 'bi bi-printer',
          class: 'btn btn-secondary',
          action: (sale) => {
            this.print(sale.reference);
          },
        },
      ],
      summableColumns: [
        { field: 'totalPriceTTC', class: 'text-primary' },
        { field: 'totalQuantity', class: '' },
        { field: 'amountPaid', class: 'text-success' },
        { field: 'amountUnpaid', class: 'text-danger' }
      ],

      tableActions: [
        {
          title: this.$t("sale12"), // Traduction du texte
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Imprimer BL",
          icon: "bi bi-printer",
          class: "btn btn-secondary",
          action: () => this.printMany(this.selections),
        },
        {
          title: this.$t("sale13"),
          icon: "bi bi-person-plus",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "sales-create" }),
        },]

      // ✅ declare filterFields
   
    };
  },
  computed: {
    ...mapGetters("sale", {
      sales: "getAll",
      totalQuantity: "getSalesTotalQuantity",
      totalPriceTTC: "getSalesTotalPriceTTC",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),

    ...mapGetters("item", {
      items: "getAll",
    }),

    filterFields() {
    return [
      {
        type: "select",
        label: "Client",
        model: "customer_reference",
        options: this.customers || [],
        labelColumn: "fullName",
        valueColumn: "reference",
      },
      {
        type: "select",
        label: "Produit",
        model: "item_reference",
        options: this.items || [],
        labelColumn: "fullName",
        valueColumn: "reference",
      },
      {
        type: "dropdown",
        label: "Statut Paiement",
        model: "paymentStatus",
        options: [
          { label: "Payé", value: "paid" },
          { label: "Impayé", value: "Unpaid" },
        ],
      },
    ];
  },
  },
  created() {
    this.$store.dispatch("customer/getAll");
    this.$store.dispatch("item/getAll");

  },
  mounted() {
    if (this.$route.query.item_reference || this.$route.query.customer_reference || this.$route.query.startDate || this.$route.query.endDate) {
      const filterData = {
        item_reference: this.$route.query.item_reference || null,
        customer_reference: this.$route.query.customer_reference || null,
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
      };
      this.filter = filterData;
      this.toFilter(filterData);
    } else {
      this.$store.dispatch("sale/fetchSales");
    }
  },

  methods: {
    async search(value) {
      return await this.$store.commit("sale/search", value);
    },
    async refresh() {
      await this.$store.dispatch("sale/fetchSales");
      await this.$store.dispatch("customer/getAll");
      await this.$store.dispatch("item/getAll");
    },

    async toFilter(data) {
      await this.$store.dispatch("sale/filter", data);
      await this.$router.push({
        name: "sales-index", query: {
          item_reference: data.item_reference,
          customer_reference: data.customer_reference,
          startDate: data.startDate,
          endDate: data.endDate,
        }
      });
    },
    async print(reference) {
      await this.$store.dispatch("sale/print", reference);
    },
    async printMany(data) {
      await this.$store.dispatch("sale/printManyBill", data);
    },
    // ✅ define resetFilter
  resetFilter() {
    this.filter = {
      customer_reference: null,
      item_reference: null,
      paymentStatus: null,
      startDate: null,
      endDate: null,
    };
    this.$store.dispatch("sale/fetchSales");
  },
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>
